export const CategoryMapping = [
  {
    'Term/Tag': 'Cakes & Bakes',
    'Term ID': 4866,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L1-Category': 'Skin',
    'L2': 'NA',
    'L2-Category': 'Dry and Dull Skin',
  },
  {
    'Term/Tag': ' Trending Hairstyles',
    'Term ID': 6651,
    'Category': 'Mylo Care',
    'L1': 'Hair',
    'L1-Category': 'Hair',
    'L2': 'NA',
    'L2-Category': 'Anti Ageing',
  },
  {
    'Term/Tag': 'Abdominal Pain',
    'Term ID': 4432,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L1-Category': 'Bath & Body',
    'L2': 'NA',
    'L2-Category': 'Skin Brightening',
  },
  {
    'Term/Tag': 'Abortion',
    'Term ID': 4423,
    'Category': 'Mylo Care',
    'L1': 'Fertility',
    'L1-Category': 'Hygiene',
    'L2': 'NA',
    'L2-Category': 'Acne and Blemishes',
  },
  {
    'Term/Tag': 'Aches & Pains',
    'Term ID': 6646,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L1-Category': 'Pregnancy & New Mom',
    'L2': 'Pain Management',
    'L2-Category': 'Skin Hydration',
  },
  {
    'Term/Tag': 'Acne',
    'Term ID': 557,
    'Category': 'Mylo Care',
    'L1': 'Skin',
    'L1-Category': 'Daily Wellness',
    'L2': 'Acne and Blemishes',
    'L2-Category': 'Dark Circles',
  },
  {
    'Term/Tag': 'Acupuncture',
    'Term ID': 4499,
    'Category': 'Mylo Care',
    'L1': 'Daily Wellness',
    'L1-Category': 'Weight',
    'L2': 'Pain Management',
    'L2-Category': 'Blackheads & Pimples',
  },
  {
    'Term/Tag': 'Adoption',
    'Term ID': 4479,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L1-Category': 'Fertility',
    'L2': 'NA',
    'L2-Category': 'Skin Moisturizer',
  },
  {
    'Term/Tag': 'Aggression',
    'Term ID': 4547,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L1-Category': 'Diapers & Wipes',
    'L2': 'NA',
    'L2-Category': 'Skin Irritation',
  },
  {
    'Term/Tag': 'Allergies',
    'Term ID': 4256,
    'Category': 'Mylo Baby',
    'L1': 'Baby Care',
    'L1-Category': 'Baby Care',
    'L2': 'NA',
    'L2-Category': 'Hair Fall',
  },
  {
    'Term/Tag': 'Anaemia',
    'Term ID': 4229,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L1-Category': 'Baby Wellness',
    'L2': 'L2',
    'L2-Category': 'Dry & Damaged Hair',
  },
  {
    'Term/Tag': 'Annaprashan',
    'Term ID': 4471,
    'Category': 'Mylo Baby',
    'L1': 'Baby Care',
    'L1-Category': 'Baby Gear',
    'L2': 'NA',
    'L2-Category': 'Hair Growth',
  },
  {
    'Term/Tag': 'Anomaly Scan',
    'Term ID': 6648,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L1-Category': 'Feeding & Lactation',
    'L2': 'NA',
    'L2-Category': 'Tan Removal',
  },
  {
    'Term/Tag': 'Antenatal Exercises',
    'Term ID': 6680,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L1-Category': 'Baby Clothing',
    'L2': 'NA',
    'L2-Category': 'Body Moisturizer',
  },
  {
    'Term/Tag': 'AntenatalClasses',
    'Term ID': 4232,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L1-Category': 'For Mom',
    'L2': 'NA',
    'L2-Category': 'Body Hydration',
  },
  {
    'Term/Tag': 'Anterior Placenta',
    'Term ID': 4420,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L1-Category': 'NA',
    'L2': 'NA',
    'L2-Category': 'Brightening',
  },
  {
    'Term/Tag': 'Antibiotics',
    'Term ID': 4441,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
    'L2-Category': 'Intimate Area Rashes',
  },
  {
    'Term/Tag': 'Appetite',
    'Term ID': 4355,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
    'L2-Category': 'UTIs & Infections',
  },
  {
    'Term/Tag': 'Appliances',
    'Term ID': 6653,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
    'L2-Category': 'Stretch Marks',
  },
  {
    'Term/Tag': 'Aroma Therapy',
    'Term ID': 4500,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
    'L2-Category': 'Lactation',
  },
  {
    'Term/Tag': 'Asthma',
    'Term ID': 6667,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
    'L2-Category': 'Maternity Wear',
  },
  {
    'Term/Tag': 'Astrology',
    'Term ID': 6657,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
    'L2-Category': 'Maternity Gear',
  },
  {
    'Term/Tag': 'Ayurveda&Homepathy',
    'Term ID': 4147,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
    'L2-Category': 'Digestive Health',
  },
  {
    'Term/Tag': 'Baby Biting',
    'Term ID': 4546,
    'Category': 'Mylo Baby',
    'L1': 'Feeding & Lactation',
    'L2': 'NA',
    'L2-Category': 'Pain Management',
  },
  {
    'Term/Tag': 'Baby Blues',
    'Term ID': 4494,
    'Category': 'Mylo Baby',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
    'L2-Category': 'Immunity',
  },
  {
    'Term/Tag': 'Baby Boy',
    'Term ID': 4516,
    'Category': 'Mylo Baby',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
    'L2-Category': 'Weight Management',
  },
  {
    'Term/Tag': 'Baby Budget',
    'Term ID': 4517,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
    'L2-Category': 'Digestive Health',
  },
  {
    'Term/Tag': 'Baby Bump',
    'Term ID': 4427,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
    'L2-Category': 'PCOS',
  },
  {
    'Term/Tag': 'Baby Care Myths & facts',
    'Term ID': 6682,
    'Category': 'Mylo Baby',
    'L1': 'Baby Care',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Baby Carrier',
    'Term ID': 4461,
    'Category': 'Mylo Baby',
    'L1': 'Baby Gear',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Baby Crowning',
    'Term ID': 4419,
    'Category': 'Mylo Baby',
    'L1': 'Baby Care',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Baby Girl',
    'Term ID': 4515,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Baby Led Weaning',
    'Term ID': 4573,
    'Category': 'Mylo Baby',
    'L1': 'Baby Care',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Baby Monitors',
    'Term ID': 4465,
    'Category': 'Mylo Baby',
    'L1': 'Baby Care',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Baby Music',
    'Term ID': 4513,
    'Category': 'Mylo Baby',
    'L1': 'Baby Care',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Baby Poop',
    'Term ID': 4549,
    'Category': 'Mylo Baby',
    'L1': 'Diapers & Wipes',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Babyaccessories',
    'Term ID': 4656,
    'Category': 'Mylo Baby',
    'L1': 'Baby Wellness',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'BabyBottles',
    'Term ID': 4575,
    'Category': 'Mylo Baby',
    'L1': 'Feeding & Lactation',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'BabyClothes',
    'Term ID': 4466,
    'Category': 'Mylo Baby',
    'L1': 'Baby Care',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'BabyGear',
    'Term ID': 4665,
    'Category': 'Mylo Baby',
    'L1': 'Baby Gear',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'BabyHealth',
    'Term ID': 4363,
    'Category': 'Mylo Baby',
    'L1': 'Baby Care',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'BabyMassage',
    'Term ID': 4197,
    'Category': 'Mylo Baby',
    'L1': 'Baby Wellness',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'BabyMoon',
    'Term ID': 4268,
    'Category': 'Mylo Baby',
    'L1': 'Baby Care',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Babynames',
    'Term ID': 574,
    'Category': 'Mylo Baby',
    'L1': 'Baby Care',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Babypillows',
    'Term ID': 4653,
    'Category': 'Mylo Baby',
    'L1': 'Baby Gear',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'babyproducts',
    'Term ID': 456,
    'Category': 'Mylo Baby',
    'L1': 'Baby Care',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'babyproducts',
    'Term ID': 5240,
    'Category': 'Mylo Baby',
    'L1': 'Baby Care',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'babyproducts',
    'Term ID': 5241,
    'Category': 'Mylo Baby',
    'L1': 'Baby Care',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Babyshower',
    'Term ID': 4201,
    'Category': 'Mylo Baby',
    'L1': 'Baby Care',
    'L2': 'L2',
  },
  {
    'Term/Tag': 'BabySleep',
    'Term ID': 4195,
    'Category': 'Mylo Baby',
    'L1': 'Baby Wellness',
    'L2': 'L2',
  },
  {
    'Term/Tag': 'BabyTowels',
    'Term ID': 4953,
    'Category': 'Mylo Baby',
    'L1': 'Baby Care',
    'L2': 'L2',
  },
  {
    'Term/Tag': 'BabyWeaning',
    'Term ID': 4192,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'L2',
  },
  {
    'Term/Tag': 'BackPain',
    'Term ID': 4312,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'L2',
    'L2-Category': 'NA',
  },
  {
    'Term/Tag': 'BasalBodyTemperature',
    'Term ID': 4536,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'L2',
  },
  {
    'Term/Tag': 'Bathing',
    'Term ID': 4191,
    'Category': 'Mylo Baby',
    'L1': 'Baby Care',
    'L2': 'L2',
  },
  {
    'Term/Tag': 'Beauty & Skincare',
    'Term ID': 6608,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'L2',
  },
  {
    'Term/Tag': 'Beauty Secrets',
    'Term ID': 6635,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'L2',
  },
  {
    'Term/Tag': 'BeautyTips',
    'Term ID': 4214,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'L2',
  },
  {
    'Term/Tag': 'Bed Time Stories',
    'Term ID': 4583,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'L2',
  },
  {
    'Term/Tag': 'Bedrest',
    'Term ID': 600,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'L2',
  },
  {
    'Term/Tag': 'Birth Partners',
    'Term ID': 6640,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'L2',
  },
  {
    'Term/Tag': 'Birthday Parties',
    'Term ID': 4468,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'L2',
  },
  {
    'Term/Tag': 'BlanketsTowelsCarriers',
    'Term ID': 4660,
    'Category': 'Mylo Baby',
    'L1': 'Baby Gear',
    'L2': 'L2',
  },
  {
    'Term/Tag': 'Bleedinggums',
    'Term ID': 542,
    'Category': 'Mylo Baby',
    'L1': 'Baby Care',
    'L2': 'L2',
  },
  {
    'Term/Tag': 'Blemishes',
    'Term ID': 4454,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'Acne and Blemishes',
  },
  {
    'Term/Tag': 'Blood Sugar Levels',
    'Term ID': 4453,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'BloodPressure',
    'Term ID': 4227,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Blurred Vision',
    'Term ID': 4435,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'BodyChanges',
    'Term ID': 4280,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Bonding',
    'Term ID': 4481,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Books',
    'Term ID': 4520,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Bottle Sterlization',
    'Term ID': 4486,
    'Category': 'Mylo Baby',
    'L1': 'Feeding & Lactation',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Bottlefeeding',
    'Term ID': 438,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'BrainDevelopment',
    'Term ID': 4244,
    'Category': 'Mylo Baby',
    'L1': 'Baby Care',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'BraxtonHicks',
    'Term ID': 4264,
    'Category': 'Mylo Baby',
    'L1': 'Baby Care',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Breast Milk',
    'Term ID': 4576,
    'Category': 'Mylo Baby',
    'L1': 'Feeding & Lactation',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Breast Pain',
    'Term ID': 4455,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'Pain Management',
  },
  {
    'Term/Tag': 'Breast Tenderness',
    'Term ID': 6663,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'Pain Management',
  },
  {
    'Term/Tag': 'Breastchanges',
    'Term ID': 512,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Breastfeeding_Barriers',
    'Term ID': 5290,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Breastfeeding_Lactation',
    'Term ID': 4571,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Breastlump',
    'Term ID': 428,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'BreathingExercises',
    'Term ID': 4231,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Breathlessless',
    'Term ID': 4311,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Breech Babies',
    'Term ID': 4324,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'BurpingYourBaby',
    'Term ID': 4189,
    'Category': 'Mylo Baby',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Car Seat',
    'Term ID': 4459,
    'Category': 'Mylo Baby',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Career and Skill Building',
    'Term ID': 6652,
    'Category': 'Mylo Baby',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Caretakers',
    'Term ID': 4288,
    'Category': 'Mylo Baby',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'CarpalTunnel',
    'Term ID': 4310,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Ceremonies',
    'Term ID': 4470,
    'Category': 'Mylo Baby',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Cervical Mucus',
    'Term ID': 4537,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Childhood Obesity',
    'Term ID': 4447,
    'Category': 'Mylo Baby',
    'L1': 'Weight',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Childproofing',
    'Term ID': 4287,
    'Category': 'Mylo Baby',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'ChineseChaska',
    'Term ID': 4862,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Cleansing Agents',
    'Term ID': 4491,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Cloth Nappies',
    'Term ID': 4462,
    'Category': 'Mylo Baby',
    'L1': 'Diapers & Wipes',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Clothdiaper',
    'Term ID': 4654,
    'Category': 'Mylo Baby',
    'L1': 'Diapers & Wipes',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Clothing/Fashion',
    'Term ID': 6609,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Clumsiness',
    'Term ID': 4309,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Cognitive Development',
    'Term ID': 4558,
    'Category': 'Mylo Baby',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Cold&Cough',
    'Term ID': 540,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Colic',
    'Term ID': 4553,
    'Category': 'Mylo Baby',
    'L1': 'Baby Wellness',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Common Health Problems',
    'Term ID': 6629,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Commuting ',
    'Term ID': 4318,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Conception',
    'Term ID': 4279,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Conception Myths & Facts',
    'Term ID': 6681,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'ConfinementPeriod',
    'Term ID': 437,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Congestion',
    'Term ID': 4308,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Constipation',
    'Term ID': 4255,
    'Category': 'Mylo Baby',
    'L1': 'Baby Wellness',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Continental Cuisine',
    'Term ID': 4864,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Contraceptive',
    'Term ID': 4545,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Contractions',
    'Term ID': 4263,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Cooking Queen ',
    'Term ID': 4895,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Coronavirus',
    'Term ID': 4822,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Coronovirus',
    'Term ID': 4823,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'CradleCap',
    'Term ID': 4254,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Crawling',
    'Term ID': 4560,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Crystal Healing',
    'Term ID': 4504,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'CSec',
    'Term ID': 4262,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'CutenessOverloaded',
    'Term ID': 4645,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'DailyCareTips',
    'Term ID': 4281,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'DayCareCenters',
    'Term ID': 4286,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'DentalHealth',
    'Term ID': 4253,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Depression',
    'Term ID': 500,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Depression in Women Post Delivery',
    'Term ID': 4175,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'DesigningANursery',
    'Term ID': 4199,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Developmental Delay',
    'Term ID': 4559,
    'Category': 'Mylo Baby',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'DevelopmentDisorders',
    'Term ID': 4243,
    'Category': 'Mylo Baby',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Diapering',
    'Term ID': 4187,
    'Category': 'Mylo Baby',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Diet & Exercise',
    'Term ID': 6607,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Diet & Nutrition for Baby',
    'Term ID': 5238,
    'Category': 'Mylo Baby',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Diet & Nutrition for Mothers',
    'Term ID': 5227,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Divorce & Separation',
    'Term ID': 4476,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'DIYKitchenHacks',
    'Term ID': 4647,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'DIYKrafts',
    'Term ID': 4648,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Dizziness',
    'Term ID': 4307,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Doctor',
    'Term ID': 4444,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Doppler',
    'Term ID': 4440,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'DueDate',
    'Term ID': 4356,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Ear Infections',
    'Term ID': 4450,
    'Category': 'Mylo Care',
    'L1': 'Daily Wellness',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Ear Wax',
    'Term ID': 4451,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Early Education',
    'Term ID': 4519,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Early Parenting',
    'Term ID': 6639,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Early Pregnancy',
    'Term ID': 4527,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Eclipse',
    'Term ID': 4497,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'EctopicPregnancy',
    'Term ID': 4225,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Emergency',
    'Term ID': 4448,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'EmotionalWellness',
    'Term ID': 4278,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Epidurals',
    'Term ID': 4326,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Episiotomy',
    'Term ID': 4261,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Evergreen Fashion Trends',
    'Term ID': 6641,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Extra Curricular',
    'Term ID': 4589,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Eye Makeup',
    'Term ID': 6642,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Face Makeup',
    'Term ID': 6643,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'False Pregnancy',
    'Term ID': 4424,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Family Management',
    'Term ID': 6633,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'FamilyLife',
    'Term ID': 4270,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'FashionTips',
    'Term ID': 4215,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Fasting',
    'Term ID': 6672,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'father',
    'Term ID': 1922,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'fatherRole',
    'Term ID': 1924,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Fears&Phobias',
    'Term ID': 4359,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Feeding Essentials You Must Have',
    'Term ID': 5067,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'FeedingSchedule',
    'Term ID': 4210,
    'Category': 'Mylo Baby',
    'L1': 'Feeding & Lactation',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Fertility Problems',
    'Term ID': 4539,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'FetalGrowth',
    'Term ID': 4235,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'FetalHeartbeat',
    'Term ID': 4234,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'FetalMovements',
    'Term ID': 4233,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Fever',
    'Term ID': 4458,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Fibroids',
    'Term ID': 6666,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Fine Motor Skills',
    'Term ID': 4556,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Finger Foods',
    'Term ID': 4574,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'First Birthday Ideas',
    'Term ID': 4469,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'FirstAid',
    'Term ID': 4285,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'FirstTrimester',
    'Term ID': 4277,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Folicacid',
    'Term ID': 489,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Food Poisoining',
    'Term ID': 4490,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'FoodAversions',
    'Term ID': 4306,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'FoodCravings',
    'Term ID': 4305,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Forgetfulness',
    'Term ID': 4436,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Formula Feeding',
    'Term ID': 4570,
    'Category': 'Mylo Baby',
    'L1': 'Feeding & Lactation',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Formula Milk',
    'Term ID': 4572,
    'Category': 'Mylo Baby',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'FrequentUrination',
    'Term ID': 4304,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Fun&Humour',
    'Term ID': 4217,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Fussy Baby',
    'Term ID': 4548,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Games',
    'Term ID': 4168,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'GarbhaSanskar',
    'Term ID': 4230,
    'Category': 'Mylo Baby',
    'L1': 'Baby Care',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Gas&Bloating',
    'Term ID': 4303,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Genetics',
    'Term ID': 4252,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Gestationaldiabetes',
    'Term ID': 670,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'GetInspired ',
    'Term ID': 4646,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Gettingpregnant',
    'Term ID': 399,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Glow-Up',
    'Term ID': 5415,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Godh Bharai',
    'Term ID': 4467,
    'Category': 'Mylo Baby',
    'L1': 'Baby Care',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Gossip',
    'Term ID': 4267,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Government Policies & Schemes',
    'Term ID': 6826,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Grandparents',
    'Term ID': 4475,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Gross Motor Skills',
    'Term ID': 4555,
    'Category': 'Mylo Baby',
    'L1': 'Baby Care',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'GrowthCharts',
    'Term ID': 4241,
    'Category': 'Mylo Baby',
    'L1': 'Baby Care',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'GujaratiAahar',
    'Term ID': 4870,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Gynecologist',
    'Term ID': 4327,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Hair Problems',
    'Term ID': 6636,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Headaches',
    'Term ID': 4302,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Health & Wellness',
    'Term ID': 6606,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Healthy Eating',
    'Term ID': 6677,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Healthy Food for Family',
    'Term ID': 6632,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'HealthyFood ',
    'Term ID': 4863,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'HearingProblems',
    'Term ID': 4364,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Heartburn',
    'Term ID': 4301,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Hemorroids',
    'Term ID': 4300,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Herbal Medicines',
    'Term ID': 4502,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Hiccups',
    'Term ID': 602,
    'Category': 'Mylo Baby',
    'L1': 'Baby Care',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'High Risk Pregnancy',
    'Term ID': 4425,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Home Decor',
    'Term ID': 6611,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Home Education',
    'Term ID': 4521,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'homeandkitchen',
    'Term ID': 4876,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Homemaker',
    'Term ID': 4358,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'HomeRemedies',
    'Term ID': 4283,
    'Category': 'Mylo Baby',
    'L1': 'Baby Care',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Hormones',
    'Term ID': 509,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'HospitalBag',
    'Term ID': 4329,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Hospitalbagessentials',
    'Term ID': 4659,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Hot Cold Sips',
    'Term ID': 4872,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'HotColdSips',
    'Term ID': 4873,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Household Chores',
    'Term ID': 4489,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'HungerPangs',
    'Term ID': 4483,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Husband/Spouse',
    'Term ID': 4473,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Hygiene & Sanitation',
    'Term ID': 4446,
    'Category': 'Mylo Care',
    'L1': 'Hygiene',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Hypnotherapy',
    'Term ID': 4505,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Illnesses&Infections',
    'Term ID': 4251,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'ImmuneSystem',
    'Term ID': 4442,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Implantation Bleeding',
    'Term ID': 4534,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Indoor Activities',
    'Term ID': 4586,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'InducedLabour',
    'Term ID': 4260,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Infections in New Mom',
    'Term ID': 432,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'InformingEmployers',
    'Term ID': 4317,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Injuries&Accidents',
    'Term ID': 4284,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Insomnia',
    'Term ID': 4299,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Introduction to Labor',
    'Term ID': 6638,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Iron Deficiency',
    'Term ID': 4443,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Is this True?',
    'Term ID': 6673,
    'Category': 'Mylo Baby',
    'L1': 'Pregnancy & New Mom',
  },
  {
    'Term/Tag': 'IVF',
    'Term ID': 671,
    'Category': 'Mylo Care',
    'L1': 'Fertility',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'IVFBaby',
    'Term ID': 4185,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'IVFPregnancy',
    'Term ID': 4276,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'JainFood',
    'Term ID': 4860,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Joint Family',
    'Term ID': 4477,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'JoysofParenting',
    'Term ID': 4649,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'kids',
    'Term ID': 1928,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'LabourInducingExercises',
    'Term ID': 4228,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'LabourPain',
    'Term ID': 4325,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Lactose Intolerance',
    'Term ID': 4579,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Language Delay',
    'Term ID': 4554,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'LanguageSkills',
    'Term ID': 4240,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Late Periods',
    'Term ID': 4529,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Late Pregnancy',
    'Term ID': 4526,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Latest Trends',
    'Term ID': 6637,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Leaking Breasts',
    'Term ID': 4578,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'LegCramps',
    'Term ID': 4298,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Leisure',
    'Term ID': 6612,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'LineaNigra',
    'Term ID': 4297,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Lip Makeup',
    'Term ID': 6645,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'Skin Moisturizer',
  },
  {
    'Term/Tag': 'Loss Of Appetite',
    'Term ID': 4484,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Loss Of Sleep',
    'Term ID': 4508,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Low Amniotic Fluid',
    'Term ID': 6665,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Low Birth Weight',
    'Term ID': 4551,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'LowLyingPlacenta',
    'Term ID': 4224,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Lullabies',
    'Term ID': 4204,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'MaharashtrianKhana',
    'Term ID': 4869,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Makeup & Cosmetics',
    'Term ID': 6670,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Makeup & Hairstyles',
    'Term ID': 6610,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Makeup Hacks',
    'Term ID': 6647,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'MaleInfertility',
    'Term ID': 4542,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Mantras & Shlokas',
    'Term ID': 4514,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Massages',
    'Term ID': 4501,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Maternity Shopping/Essentials',
    'Term ID': 6644,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'Maternity Wear',
  },
  {
    'Term/Tag': 'MaternityBenefits',
    'Term ID': 4316,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'MaternityFashion',
    'Term ID': 4266,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'Maternity Wear',
  },
  {
    'Term/Tag': 'MaternityHospital',
    'Term ID': 4328,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'MaternityLeave',
    'Term ID': 663,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Medical Tourism',
    'Term ID': 4437,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'MedicalProcedures',
    'Term ID': 4250,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Medications',
    'Term ID': 4249,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Meditation',
    'Term ID': 4503,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'MenstrualCycle',
    'Term ID': 4528,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Migraine',
    'Term ID': 564,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'Pain Management',
  },
  {
    'Term/Tag': 'Milestones',
    'Term ID': 4239,
    'Category': 'Mylo Baby',
    'L1': 'NA',
  },
  {
    'Term/Tag': 'Miscarriage',
    'Term ID': 423,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Missed Period',
    'Term ID': 6661,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Mobile Usage',
    'Term ID': 4439,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Momfluencers',
    'Term ID': 5515,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'MoodSwings',
    'Term ID': 4296,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Mosquito Prevention',
    'Term ID': 4904,
    'Category': 'Mylo Baby',
    'L1': 'Baby Wellness',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Motherhood',
    'Term ID': 4334,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'motherRole',
    'Term ID': 5272,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'MothersFirstMilk',
    'Term ID': 551,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'MotorSkills',
    'Term ID': 4238,
    'Category': 'Mylo Baby',
    'L1': 'Baby Care',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Music',
    'Term ID': 6658,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Nail Care',
    'Term ID': 6650,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Naps',
    'Term ID': 4512,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Nausea&Vomiting',
    'Term ID': 4295,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Nerve-Related Issues',
    'Term ID': 6631,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'NewbornCare',
    'Term ID': 4182,
    'Category': 'Mylo Baby',
    'L1': 'Baby Care',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'NewParent',
    'Term ID': 4569,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'NormalDelivery',
    'Term ID': 4259,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'NorthIndian',
    'Term ID': 4859,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Nose Bleeding',
    'Term ID': 4431,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Nuchal Translucency Scan (NT Scan)',
    'Term ID': 6649,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Nutrition Tips',
    'Term ID': 4220,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Nutritionist',
    'Term ID': 580,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Obesity',
    'Term ID': 4457,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'Weight Management',
  },
  {
    'Term/Tag': 'Oils',
    'Term ID': 4488,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'Hair Growth',
  },
  {
    'Term/Tag': 'Outdoor Activities',
    'Term ID': 4587,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Ovaries',
    'Term ID': 4530,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Over Sleeping',
    'Term ID': 4510,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Overweight',
    'Term ID': 593,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'Weight Management',
  },
  {
    'Term/Tag': 'Ovulation Prediction Kits',
    'Term ID': 4538,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'ParentingTips',
    'Term ID': 4206,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'PaternityLeave',
    'Term ID': 406,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'PCOS & PCOD',
    'Term ID': 4221,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'PCOS',
  },
  {
    'Term/Tag': 'Pediatrician',
    'Term ID': 4445,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'PelvicFloorExercies',
    'Term ID': 4226,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Periods',
    'Term ID': 4535,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Personalcare',
    'Term ID': 4880,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Pets',
    'Term ID': 4492,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'PhysicalGrowth',
    'Term ID': 4237,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Pica',
    'Term ID': 4430,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Pilates',
    'Term ID': 4482,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Placental Abruption',
    'Term ID': 6668,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Play Dates',
    'Term ID': 4588,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Play School',
    'Term ID': 4523,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'PlayActivities',
    'Term ID': 4166,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Positive Parenting',
    'Term ID': 4567,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Post Term Pregnancy',
    'Term ID': 4426,
    'Category': 'Mylo Baby',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Posterior Placenta',
    'Term ID': 4421,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'PottyTraining',
    'Term ID': 4282,
    'Category': 'Mylo Baby',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Preeclampsia',
    'Term ID': 420,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Pregnancy At 30',
    'Term ID': 4524,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Pregnancy At 40',
    'Term ID': 4525,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Pregnancy Best Foods',
    'Term ID': 6676,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': "Pregnancy Dos & Don'ts",
    'Term ID': 6675,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Pregnancy Precautions',
    'Term ID': 6662,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'PregnancyBrain',
    'Term ID': 4294,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'PregnancyBump',
    'Term ID': 4275,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'PregnancyDietChart',
    'Term ID': 4637,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'PregnancyMusic',
    'Term ID': 4331,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'PregnancyTests',
    'Term ID': 4274,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'PrematureBabies',
    'Term ID': 4258,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'PrematureDelivery',
    'Term ID': 4257,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Prenatal Tests',
    'Term ID': 6664,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Prenatal yoga',
    'Term ID': 6679,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'PrenatalVisits',
    'Term ID': 4248,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'PreparingForDelivery',
    'Term ID': 164,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Preparingforschool',
    'Term ID': 4522,
    'Category': 'Mylo Baby',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Preschool',
    'Term ID': 4518,
    'Category': 'Mylo Baby',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'preschoolers',
    'Term ID': 1927,
    'Category': 'Mylo Baby',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'PretermLabour',
    'Term ID': 4321,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Problems In Conceiving',
    'Term ID': 4541,
    'Category': 'Mylo Care',
    'L1': 'Fertility',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Products&Services',
    'Term ID': 4415,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Psychological Development',
    'Term ID': 4557,
    'Category': 'Mylo Baby',
    'L1': 'NA',
  },
  {
    'Term/Tag': 'Pumping',
    'Term ID': 4208,
    'Category': 'Mylo Baby',
    'L1': 'Feeding & Lactation',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'RajasthaniBhojan',
    'Term ID': 4871,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Rashes',
    'Term ID': 4452,
    'Category': 'Mylo Baby',
    'L1': 'Baby Wellness',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Reading',
    'Term ID': 4582,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Recipes',
    'Term ID': 4216,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Reflexology',
    'Term ID': 4506,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Regular Health Checkup',
    'Term ID': 6630,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Relationships',
    'Term ID': 6634,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Rhymes',
    'Term ID': 4590,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Rituals & Customs',
    'Term ID': 4472,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Role Of A Father',
    'Term ID': 4565,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Role Of A Partner',
    'Term ID': 4474,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Round Ligament Pain',
    'Term ID': 4433,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Safe exercise in pregnancy',
    'Term ID': 6678,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Scans&Tests',
    'Term ID': 4247,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Screen Time',
    'Term ID': 4585,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Second Child',
    'Term ID': 4480,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'SecondaryFertility',
    'Term ID': 4540,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'SecondTrimester',
    'Term ID': 4272,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Sensory Development',
    'Term ID': 4564,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Separation  Anxiety',
    'Term ID': 4496,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Sex During Pregnancy',
    'Term ID': 6671,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'SexLife',
    'Term ID': 4269,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Sibling Rivalry',
    'Term ID': 4478,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Siblings',
    'Term ID': 576,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'SIDS',
    'Term ID': 4552,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Single Parent',
    'Term ID': 4566,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Sitting',
    'Term ID': 4562,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Skin & Hair',
    'Term ID': 4487,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Skin Problems',
    'Term ID': 4449,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Skinchanges',
    'Term ID': 506,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Sleep Deprivation',
    'Term ID': 4511,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Sleep Time Essentials',
    'Term ID': 4715,
    'Category': 'Mylo Baby',
    'L1': 'Baby Gear',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Sleeping OnThe Back',
    'Term ID': 4507,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Sleeping Problems',
    'Term ID': 4509,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'SleepingPositions',
    'Term ID': 4273,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Smiling',
    'Term ID': 4563,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Snoring',
    'Term ID': 538,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'SocialDevelopment',
    'Term ID': 4236,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Soothers',
    'Term ID': 4207,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Sore Breasts',
    'Term ID': 4577,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'South Indian Food',
    'Term ID': 4865,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'SpermAndEggDonation',
    'Term ID': 4544,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'SpiderVeins/RedVeins',
    'Term ID': 4434,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Spirituality',
    'Term ID': 6656,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Starting Solids',
    'Term ID': 4223,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'StayAtHomeParent',
    'Term ID': 4320,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'StemCellBanking',
    'Term ID': 4330,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Stories',
    'Term ID': 4584,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Strangers  Anxiety',
    'Term ID': 4495,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'StreetFood',
    'Term ID': 4861,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Stress',
    'Term ID': 4172,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Stretch Marks',
    'Term ID': 4362,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Stroller/Pram',
    'Term ID': 4460,
    'Category': 'Mylo Baby',
    'L1': 'Baby Gear',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Stuffy Nose',
    'Term ID': 4428,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Styling Tips',
    'Term ID': 6654,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Surrogacy',
    'Term ID': 4543,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Swaddling',
    'Term ID': 4180,
    'Category': 'Mylo Baby',
    'L1': 'Baby Clothing',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'SweetTreats',
    'Term ID': 4867,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'SwollenLegs',
    'Term ID': 4293,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Symptoms & Illnesses',
    'Term ID': 6674,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Technology & Gadgets',
    'Term ID': 4438,
    'Category': 'Mylo Care',
    'L1': 'L1',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Teeth Grinding',
    'Term ID': 4313,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'TeethBlisters',
    'Term ID': 4315,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Teethers',
    'Term ID': 4314,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Therapies',
    'Term ID': 4498,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'ThirdTrimester',
    'Term ID': 4271,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Tiredness&Fatigue',
    'Term ID': 4292,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Tooth Decay',
    'Term ID': 4580,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Tooth Eruption',
    'Term ID': 4581,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Toys&Gifts',
    'Term ID': 4164,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Travel&Holidays',
    'Term ID': 4265,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'TV & OTT',
    'Term ID': 6659,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Twins&Triplets',
    'Term ID': 4332,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Types Of Parenting',
    'Term ID': 4568,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Umbilical Cord',
    'Term ID': 4550,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Umbilical Cord Complications',
    'Term ID': 6669,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Umbilical Hernia',
    'Term ID': 4422,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Upholstery & Furnishing',
    'Term ID': 6655,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'UTI',
    'Term ID': 4456,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Vaccinations',
    'Term ID': 4246,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Vaginal Bleeding',
    'Term ID': 4533,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Vaginal Discharge',
    'Term ID': 4531,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'VaricoseVeins',
    'Term ID': 4291,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Vertigo',
    'Term ID': 4290,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Vitamins&Supplements',
    'Term ID': 4245,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Vivid Dreams',
    'Term ID': 4429,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Walking',
    'Term ID': 4561,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'WaterBirth',
    'Term ID': 4323,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'WaterBreak',
    'Term ID': 4322,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Weaning',
    'Term ID': 4222,
    'Category': 'Mylo Baby',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Weight Loss',
    'Term ID': 4218,
    'Category': 'Mylo Care',
    'L1': 'Weight',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Weight Related Problems',
    'Term ID': 6628,
    'Category': 'Mylo Care',
    'L1': 'Weight',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'WeightGain',
    'Term ID': 4219,
    'Category': 'Mylo Care',
    'L1': 'Weight',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'White Discharge',
    'Term ID': 4532,
    'Category': 'Mylo Care',
    'L1': 'Hygiene',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Winter Care',
    'Term ID': 4485,
    'Category': 'Mylo Care',
    'L1': 'Baby Care',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Winter Store',
    'Term ID': 4995,
    'Category': 'Mylo Baby',
    'L1': 'Baby Clothing',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Women Specific Issues',
    'Term ID': 6627,
    'Category': 'Mylo Care',
    'L1': 'Daily Wellness',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Work place',
    'Term ID': 4493,
    'Category': 'Mylo Care',
    'L1': 'NA',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'WorkingParent',
    'Term ID': 4319,
    'Category': 'Mylo Care',
    'L1': 'Pregnancy & New Mom',
    'L2': 'NA',
  },
  {
    'Term/Tag': 'Yoga',
    'Term ID': 589,
    'Category': ' Mylo Care',
    'L1': 'Daily Wellness',
    'L2': 'NA',
  },
];

export const updatedCategoryMapping = {
  'cakes&bakes': {
    term_id: 4866,
    subtab_name: 'Mylo Care',
    l1_category: 'Skin',
    l2_category: 'Dry and Dull Skin',
  },
  'trendinghairstyles': {
    term_id: 6651,
    subtab_name: 'Mylo Care',
    l1_category: 'Hair-Hair',
    l2_category: 'Anti Ageing',
  },
  'abdominalpain': {
    term_id: 4432,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom-Bath & Body',
    l2_category: 'Skin Brightening',
  },
  'abortion': {
    term_id: 4423,
    subtab_name: 'Mylo Care',
    l1_category: 'Fertility-Hygiene',
    l2_category: 'Acne and Blemishes',
  },
  'aches&pains': {
    term_id: 6646,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom-Pregnancy & New Mom',
    l2_category: 'Pain Management-Skin Hydration',
  },
  'acne': {
    term_id: 557,
    subtab_name: 'Mylo Care',
    l1_category: 'Skin-Daily Wellness',
    l2_category: 'Acne and Blemishes-Dark Circles',
  },
  'acupuncture': {
    term_id: 4499,
    subtab_name: 'Mylo Care',
    l1_category: 'Daily Wellness-Weight',
    l2_category: 'Pain Management-Blackheads & Pimples',
  },
  'adoption': {
    term_id: 4479,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom-Fertility',
    l2_category: 'Skin Moisturizer',
  },
  'aggression': {
    term_id: 4547,
    subtab_name: 'Mylo Care',
    l1_category: 'Diapers & Wipes',
    l2_category: 'Skin Irritation',
  },
  'allergies': {
    term_id: 4256,
    subtab_name: 'Mylo Baby',
    l1_category: 'Baby Care-Baby Care',
    l2_category: 'Hair Fall',
  },
  'anaemia': {
    term_id: 4229,
    subtab_name: 'Mylo Care',
    l1_category: 'Baby Wellness',
    l2_category: 'Dry & Damaged Hair',
  },
  'annaprashan': {
    term_id: 4471,
    subtab_name: 'Mylo Baby',
    l1_category: 'Baby Care-Baby Gear',
    l2_category: 'Hair Growth',
  },
  'anomalyscan': {
    term_id: 6648,
    subtab_name: 'Mylo Care',
    l1_category: 'Feeding & Lactation',
    l2_category: 'Tan Removal',
  },
  'antenatalexercises': {
    term_id: 6680,
    subtab_name: 'Mylo Care',
    l1_category: 'Baby Clothing',
    l2_category: 'Body Moisturizer',
  },
  'antenatalclasses': {
    term_id: 4232,
    subtab_name: 'Mylo Care',
    l1_category: 'For Mom',
    l2_category: 'Body Hydration',
  },
  'anteriorplacenta': {
    term_id: 4420,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'Brightening',
  },
  'antibiotics': {
    term_id: 4441,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'Intimate Area Rashes',
  },
  'appetite': {
    term_id: 4355,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'UTIs & Infections',
  },
  'appliances': {
    term_id: 6653,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'Stretch Marks',
  },
  'aromatherapy': {
    term_id: 4500,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'Lactation',
  },
  'asthma': {
    term_id: 6667,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'Maternity Wear',
  },
  'astrology': {
    term_id: 6657,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'Maternity Gear',
  },
  'ayurveda&homepathy': {
    term_id: 4147,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'Digestive Health',
  },
  'babybiting': {
    term_id: 4546,
    subtab_name: 'Mylo Baby',
    l1_category: 'Feeding & Lactation',
    l2_category: 'Pain Management',
  },
  'babyblues': {
    term_id: 4494,
    subtab_name: 'Mylo Baby',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'Immunity',
  },
  'babyboy': {
    term_id: 4516,
    subtab_name: 'Mylo Baby',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'Weight Management',
  },
  'babybudget': {
    term_id: 4517,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'Digestive Health',
  },
  'babybump': {
    term_id: 4427,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'PCOS',
  },
  'babycaremyths&facts': {
    term_id: 6682,
    subtab_name: 'Mylo Baby',
    l1_category: 'Baby Care',
    l2_category: 'NA',
  },
  'babycarrier': {
    term_id: 4461,
    subtab_name: 'Mylo Baby',
    l1_category: 'Baby Gear',
    l2_category: 'NA',
  },
  'babycrowning': {
    term_id: 4419,
    subtab_name: 'Mylo Baby',
    l1_category: 'Baby Care',
    l2_category: 'NA',
  },
  'babygirl': {
    term_id: 4515,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'babyledweaning': {
    term_id: 4573,
    subtab_name: 'Mylo Baby',
    l1_category: 'Baby Care',
    l2_category: 'NA',
  },
  'babymonitors': {
    term_id: 4465,
    subtab_name: 'Mylo Baby',
    l1_category: 'Baby Care',
    l2_category: 'NA',
  },
  'babymusic': {
    term_id: 4513,
    subtab_name: 'Mylo Baby',
    l1_category: 'Baby Care',
    l2_category: 'NA',
  },
  'babypoop': {
    term_id: 4549,
    subtab_name: 'Mylo Baby',
    l1_category: 'Diapers & Wipes',
    l2_category: 'NA',
  },
  'babyaccessories': {
    term_id: 4656,
    subtab_name: 'Mylo Baby',
    l1_category: 'Baby Wellness',
    l2_category: 'NA',
  },
  'babybottles': {
    term_id: 4575,
    subtab_name: 'Mylo Baby',
    l1_category: 'Feeding & Lactation',
    l2_category: 'NA',
  },
  'babyclothes': {
    term_id: 4466,
    subtab_name: 'Mylo Baby',
    l1_category: 'Baby Care',
    l2_category: 'NA',
  },
  'babygear': {
    term_id: 4665,
    subtab_name: 'Mylo Baby',
    l1_category: 'Baby Gear',
    l2_category: 'NA',
  },
  'babyhealth': {
    term_id: 4363,
    subtab_name: 'Mylo Baby',
    l1_category: 'Baby Care',
    l2_category: 'NA',
  },
  'babymassage': {
    term_id: 4197,
    subtab_name: 'Mylo Baby',
    l1_category: 'Baby Wellness',
    l2_category: 'NA',
  },
  'babymoon': {
    term_id: 4268,
    subtab_name: 'Mylo Baby',
    l1_category: 'Baby Care',
    l2_category: 'NA',
  },
  'babynames': {
    term_id: 574,
    subtab_name: 'Mylo Baby',
    l1_category: 'Baby Care',
    l2_category: 'NA',
  },
  'babypillows': {
    term_id: 4653,
    subtab_name: 'Mylo Baby',
    l1_category: 'Baby Gear',
    l2_category: 'NA',
  },
  'babyproducts': {
    term_id: 5241,
    subtab_name: 'Mylo Baby',
    l1_category: 'Baby Care',
    l2_category: 'NA',
  },
  'babyshower': {
    term_id: 4201,
    subtab_name: 'Mylo Baby',
    l1_category: 'Baby Care',
    l2_category: 'NA',
  },
  'babysleep': {
    term_id: 4195,
    subtab_name: 'Mylo Baby',
    l1_category: 'Baby Wellness',
    l2_category: 'NA',
  },
  'babytowels': {
    term_id: 4953,
    subtab_name: 'Mylo Baby',
    l1_category: 'Baby Care',
    l2_category: 'NA',
  },
  'babyweaning': {
    term_id: 4192,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'backpain': {
    term_id: 4312,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'basalbodytemperature': {
    term_id: 4536,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'bathing': {
    term_id: 4191,
    subtab_name: 'Mylo Baby',
    l1_category: 'Baby Care',
    l2_category: 'NA',
  },
  'beauty&skincare': {
    term_id: 6608,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'beautysecrets': {
    term_id: 6635,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'beautytips': {
    term_id: 4214,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'bedtimestories': {
    term_id: 4583,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'bedrest': {
    term_id: 600,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'birthpartners': {
    term_id: 6640,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'birthdayparties': {
    term_id: 4468,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'blanketstowelscarriers': {
    term_id: 4660,
    subtab_name: 'Mylo Baby',
    l1_category: 'Baby Gear',
    l2_category: 'NA',
  },
  'bleedinggums': {
    term_id: 542,
    subtab_name: 'Mylo Baby',
    l1_category: 'Baby Care',
    l2_category: 'NA',
  },
  'blemishes': {
    term_id: 4454,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'Acne and Blemishes',
  },
  'bloodsugarlevels': {
    term_id: 4453,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'bloodpressure': {
    term_id: 4227,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'blurredvision': {
    term_id: 4435,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'bodychanges': {
    term_id: 4280,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'bonding': {
    term_id: 4481,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'books': {
    term_id: 4520,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'bottlesterlization': {
    term_id: 4486,
    subtab_name: 'Mylo Baby',
    l1_category: 'Feeding & Lactation',
    l2_category: 'NA',
  },
  'bottlefeeding': {
    term_id: 438,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'braindevelopment': {
    term_id: 4244,
    subtab_name: 'Mylo Baby',
    l1_category: 'Baby Care',
    l2_category: 'NA',
  },
  'braxtonhicks': {
    term_id: 4264,
    subtab_name: 'Mylo Baby',
    l1_category: 'Baby Care',
    l2_category: 'NA',
  },
  'breastmilk': {
    term_id: 4576,
    subtab_name: 'Mylo Baby',
    l1_category: 'Feeding & Lactation',
    l2_category: 'NA',
  },
  'breastpain': {
    term_id: 4455,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'Pain Management',
  },
  'breasttenderness': {
    term_id: 6663,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'Pain Management',
  },
  'breastchanges': {
    term_id: 512,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'breastfeeding_barriers': {
    term_id: 5290,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'breastfeeding_lactation': {
    term_id: 4571,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'breastlump': {
    term_id: 428,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'breathingexercises': {
    term_id: 4231,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'breathlessless': {
    term_id: 4311,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'breechbabies': {
    term_id: 4324,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'burpingyourbaby': {
    term_id: 4189,
    subtab_name: 'Mylo Baby',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'carseat': {
    term_id: 4459,
    subtab_name: 'Mylo Baby',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'careerandskillbuilding': {
    term_id: 6652,
    subtab_name: 'Mylo Baby',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'caretakers': {
    term_id: 4288,
    subtab_name: 'Mylo Baby',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'carpaltunnel': {
    term_id: 4310,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'ceremonies': {
    term_id: 4470,
    subtab_name: 'Mylo Baby',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'cervicalmucus': {
    term_id: 4537,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'childhoodobesity': {
    term_id: 4447,
    subtab_name: 'Mylo Baby',
    l1_category: 'Weight',
    l2_category: 'NA',
  },
  'childproofing': {
    term_id: 4287,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'chinesechaska': {
    term_id: 4862,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'cleansingagents': {
    term_id: 4491,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'clothnappies': {
    term_id: 4462,
    subtab_name: 'Mylo Baby',
    l1_category: 'Diapers & Wipes',
    l2_category: 'NA',
  },
  'clothdiaper': {
    term_id: 4654,
    subtab_name: 'Mylo Baby',
    l1_category: 'Diapers & Wipes',
    l2_category: 'NA',
  },
  'clothing/fashion': {
    term_id: 6609,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'clumsiness': {
    term_id: 4309,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'cognitivedevelopment': {
    term_id: 4558,
    subtab_name: 'Mylo Baby',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'cold&cough': {
    term_id: 540,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'colic': {
    term_id: 4553,
    subtab_name: 'Mylo Baby',
    l1_category: 'Baby Wellness',
    l2_category: 'NA',
  },
  'commonhealthproblems': {
    term_id: 6629,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'commuting': {
    term_id: 4318,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'conception': {
    term_id: 4279,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'conceptionmyths&facts': {
    term_id: 6681,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'confinementperiod': {
    term_id: 437,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'congestion': {
    term_id: 4308,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'constipation': {
    term_id: 4255,
    subtab_name: 'Mylo Baby',
    l1_category: 'Baby Wellness',
    l2_category: 'NA',
  },
  'continentalcuisine': {
    term_id: 4864,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'contraceptive': {
    term_id: 4545,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'contractions': {
    term_id: 4263,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'cookingqueen': {
    term_id: 4895,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'coronavirus': {
    term_id: 4822,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'coronovirus': {
    term_id: 4823,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'cradlecap': {
    term_id: 4254,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'crawling': {
    term_id: 4560,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'crystalhealing': {
    term_id: 4504,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'csec': {
    term_id: 4262,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'cutenessoverloaded': {
    term_id: 4645,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'dailycaretips': {
    term_id: 4281,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'daycarecenters': {
    term_id: 4286,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'dentalhealth': {
    term_id: 4253,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'depression': {
    term_id: 500,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'depressioninwomenpostdelivery': {
    term_id: 4175,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'designinganursery': {
    term_id: 4199,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'developmentaldelay': {
    term_id: 4559,
    subtab_name: 'Mylo Baby',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'developmentdisorders': {
    term_id: 4243,
    subtab_name: 'Mylo Baby',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'diapering': {
    term_id: 4187,
    subtab_name: 'Mylo Baby',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'diet&exercise': {
    term_id: 6607,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'diet&nutritionforbaby': {
    term_id: 5238,
    subtab_name: 'Mylo Baby',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'diet&nutritionformothers': {
    term_id: 5227,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'divorce&separation': {
    term_id: 4476,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'diykitchenhacks': {
    term_id: 4647,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'diykrafts': {
    term_id: 4648,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'dizziness': {
    term_id: 4307,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'doctor': {
    term_id: 4444,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'doppler': {
    term_id: 4440,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'duedate': {
    term_id: 4356,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'earinfections': {
    term_id: 4450,
    subtab_name: 'Mylo Care',
    l1_category: 'Daily Wellness',
    l2_category: 'NA',
  },
  'earwax': {
    term_id: 4451,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'earlyeducation': {
    term_id: 4519,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'earlyparenting': {
    term_id: 6639,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'earlypregnancy': {
    term_id: 4527,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'eclipse': {
    term_id: 4497,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'ectopicpregnancy': {
    term_id: 4225,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'emergency': {
    term_id: 4448,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'emotionalwellness': {
    term_id: 4278,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'epidurals': {
    term_id: 4326,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'episiotomy': {
    term_id: 4261,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'evergreenfashiontrends': {
    term_id: 6641,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'extracurricular': {
    term_id: 4589,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'eyemakeup': {
    term_id: 6642,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'facemakeup': {
    term_id: 6643,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'falsepregnancy': {
    term_id: 4424,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'familymanagement': {
    term_id: 6633,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'familylife': {
    term_id: 4270,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'fashiontips': {
    term_id: 4215,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'fasting': {
    term_id: 6672,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'father': {
    term_id: 1922,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'fatherrole': {
    term_id: 1924,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'fears&phobias': {
    term_id: 4359,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'feedingessentialsyoumusthave': {
    term_id: 5067,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'feedingschedule': {
    term_id: 4210,
    subtab_name: 'Mylo Baby',
    l1_category: 'Feeding & Lactation',
    l2_category: 'NA',
  },
  'fertilityproblems': {
    term_id: 4539,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'fetalgrowth': {
    term_id: 4235,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'fetalheartbeat': {
    term_id: 4234,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'fetalmovements': {
    term_id: 4233,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'fever': {
    term_id: 4458,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'fibroids': {
    term_id: 6666,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'finemotorskills': {
    term_id: 4556,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'fingerfoods': {
    term_id: 4574,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'firstbirthdayideas': {
    term_id: 4469,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'firstaid': {
    term_id: 4285,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'firsttrimester': {
    term_id: 4277,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'folicacid': {
    term_id: 489,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'foodpoisoining': {
    term_id: 4490,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'foodaversions': {
    term_id: 4306,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'foodcravings': {
    term_id: 4305,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'forgetfulness': {
    term_id: 4436,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'formulafeeding': {
    term_id: 4570,
    subtab_name: 'Mylo Baby',
    l1_category: 'Feeding & Lactation',
    l2_category: 'NA',
  },
  'formulamilk': {
    term_id: 4572,
    subtab_name: 'Mylo Baby',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'frequenturination': {
    term_id: 4304,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'fun&humour': {
    term_id: 4217,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'fussybaby': {
    term_id: 4548,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'games': {
    term_id: 4168,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'garbhasanskar': {
    term_id: 4230,
    subtab_name: 'Mylo Baby',
    l1_category: 'Baby Care',
    l2_category: 'NA',
  },
  'gas&bloating': {
    term_id: 4303,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'genetics': {
    term_id: 4252,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'gestationaldiabetes': {
    term_id: 670,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'getinspired': {
    term_id: 4646,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'gettingpregnant': {
    term_id: 399,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'glow-up': {
    term_id: 5415,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'godhbharai': {
    term_id: 4467,
    subtab_name: 'Mylo Baby',
    l1_category: 'Baby Care',
    l2_category: 'NA',
  },
  'gossip': {
    term_id: 4267,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'governmentpolicies&schemes': {
    term_id: 6826,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'grandparents': {
    term_id: 4475,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'grossmotorskills': {
    term_id: 4555,
    subtab_name: 'Mylo Baby',
    l1_category: 'Baby Care',
    l2_category: 'NA',
  },
  'growthcharts': {
    term_id: 4241,
    subtab_name: 'Mylo Baby',
    l1_category: 'Baby Care',
    l2_category: 'NA',
  },
  'gujaratiaahar': {
    term_id: 4870,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'gynecologist': {
    term_id: 4327,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'hairproblems': {
    term_id: 6636,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'headaches': {
    term_id: 4302,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'health&wellness': {
    term_id: 6606,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'healthyeating': {
    term_id: 6677,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'healthyfoodforfamily': {
    term_id: 6632,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'healthyfood': {
    term_id: 4863,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'hearingproblems': {
    term_id: 4364,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'heartburn': {
    term_id: 4301,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'hemorroids': {
    term_id: 4300,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'herbalmedicines': {
    term_id: 4502,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'hiccups': {
    term_id: 602,
    subtab_name: 'Mylo Baby',
    l1_category: 'Baby Care',
    l2_category: 'NA',
  },
  'highriskpregnancy': {
    term_id: 4425,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'homedecor': {
    term_id: 6611,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'homeeducation': {
    term_id: 4521,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'homeandkitchen': {
    term_id: 4876,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'homemaker': {
    term_id: 4358,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'homeremedies': {
    term_id: 4283,
    subtab_name: 'Mylo Baby',
    l1_category: 'Baby Care',
    l2_category: 'NA',
  },
  'hormones': {
    term_id: 509,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'hospitalbag': {
    term_id: 4329,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'hospitalbagessentials': {
    term_id: 4659,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'hotcoldsips': {
    term_id: 4873,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'householdchores': {
    term_id: 4489,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'hungerpangs': {
    term_id: 4483,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'husband/spouse': {
    term_id: 4473,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'hygiene&sanitation': {
    term_id: 4446,
    subtab_name: 'Mylo Care',
    l1_category: 'Hygiene',
    l2_category: 'NA',
  },
  'hypnotherapy': {
    term_id: 4505,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'illnesses&infections': {
    term_id: 4251,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'immunesystem': {
    term_id: 4442,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'implantationbleeding': {
    term_id: 4534,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'indooractivities': {
    term_id: 4586,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'inducedlabour': {
    term_id: 4260,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'infectionsinnewmom': {
    term_id: 432,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'informingemployers': {
    term_id: 4317,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'injuries&accidents': {
    term_id: 4284,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'insomnia': {
    term_id: 4299,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'introductiontolabor': {
    term_id: 6638,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'irondeficiency': {
    term_id: 4443,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'isthistrue?': {
    term_id: 6673,
    subtab_name: 'Mylo Baby',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'undefined',
  },
  'ivf': {
    term_id: 671,
    subtab_name: 'Mylo Care',
    l1_category: 'Fertility',
    l2_category: 'NA',
  },
  'ivfbaby': {
    term_id: 4185,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'ivfpregnancy': {
    term_id: 4276,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'jainfood': {
    term_id: 4860,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'jointfamily': {
    term_id: 4477,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'joysofparenting': {
    term_id: 4649,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'kids': {
    term_id: 1928,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'labourinducingexercises': {
    term_id: 4228,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'labourpain': {
    term_id: 4325,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'lactoseintolerance': {
    term_id: 4579,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'languagedelay': {
    term_id: 4554,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'languageskills': {
    term_id: 4240,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'lateperiods': {
    term_id: 4529,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'latepregnancy': {
    term_id: 4526,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'latesttrends': {
    term_id: 6637,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'leakingbreasts': {
    term_id: 4578,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'legcramps': {
    term_id: 4298,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'leisure': {
    term_id: 6612,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'lineanigra': {
    term_id: 4297,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'lipmakeup': {
    term_id: 6645,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'Skin Moisturizer',
  },
  'lossofappetite': {
    term_id: 4484,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'lossofsleep': {
    term_id: 4508,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'lowamnioticfluid': {
    term_id: 6665,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'lowbirthweight': {
    term_id: 4551,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'lowlyingplacenta': {
    term_id: 4224,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'lullabies': {
    term_id: 4204,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'maharashtriankhana': {
    term_id: 4869,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'makeup&cosmetics': {
    term_id: 6670,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'makeup&hairstyles': {
    term_id: 6610,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'makeuphacks': {
    term_id: 6647,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'maleinfertility': {
    term_id: 4542,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'mantras&shlokas': {
    term_id: 4514,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'massages': {
    term_id: 4501,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'maternityshopping/essentials': {
    term_id: 6644,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'Maternity Wear',
  },
  'maternitybenefits': {
    term_id: 4316,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'maternityfashion': {
    term_id: 4266,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'Maternity Wear',
  },
  'maternityhospital': {
    term_id: 4328,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'maternityleave': {
    term_id: 663,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'medicaltourism': {
    term_id: 4437,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'medicalprocedures': {
    term_id: 4250,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'medications': {
    term_id: 4249,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'meditation': {
    term_id: 4503,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'menstrualcycle': {
    term_id: 4528,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'migraine': {
    term_id: 564,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'Pain Management',
  },
  'milestones': {
    term_id: 4239,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'undefined',
  },
  'miscarriage': {
    term_id: 423,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'missedperiod': {
    term_id: 6661,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'mobileusage': {
    term_id: 4439,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'momfluencers': {
    term_id: 5515,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'moodswings': {
    term_id: 4296,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'mosquitoprevention': {
    term_id: 4904,
    subtab_name: 'Mylo Baby',
    l1_category: 'Baby Wellness',
    l2_category: 'NA',
  },
  'motherhood': {
    term_id: 4334,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'motherrole': {
    term_id: 5272,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'mothersfirstmilk': {
    term_id: 551,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'motorskills': {
    term_id: 4238,
    subtab_name: 'Mylo Baby',
    l1_category: 'Baby Care',
    l2_category: 'NA',
  },
  'music': {
    term_id: 6658,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'nailcare': {
    term_id: 6650,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'naps': {
    term_id: 4512,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'nausea&vomiting': {
    term_id: 4295,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'nerve-relatedissues': {
    term_id: 6631,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'newborncare': {
    term_id: 4182,
    subtab_name: 'Mylo Baby',
    l1_category: 'Baby Care',
    l2_category: 'NA',
  },
  'newparent': {
    term_id: 4569,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'normaldelivery': {
    term_id: 4259,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'northindian': {
    term_id: 4859,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'nosebleeding': {
    term_id: 4431,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'nuchaltranslucencyscan(ntscan)': {
    term_id: 6649,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'nutritiontips': {
    term_id: 4220,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'nutritionist': {
    term_id: 580,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'obesity': {
    term_id: 4457,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'Weight Management',
  },
  'oils': {
    term_id: 4488,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'Hair Growth',
  },
  'outdooractivities': {
    term_id: 4587,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'ovaries': {
    term_id: 4530,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'oversleeping': {
    term_id: 4510,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'overweight': {
    term_id: 593,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'Weight Management',
  },
  'ovulationpredictionkits': {
    term_id: 4538,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'parentingtips': {
    term_id: 4206,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'paternityleave': {
    term_id: 406,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'pcos&pcod': {
    term_id: 4221,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'PCOS',
  },
  'pediatrician': {
    term_id: 4445,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'pelvicfloorexercies': {
    term_id: 4226,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'periods': {
    term_id: 4535,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'personalcare': {
    term_id: 4880,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'pets': {
    term_id: 4492,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'physicalgrowth': {
    term_id: 4237,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'pica': {
    term_id: 4430,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'pilates': {
    term_id: 4482,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'placentalabruption': {
    term_id: 6668,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'playdates': {
    term_id: 4588,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'playschool': {
    term_id: 4523,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'playactivities': {
    term_id: 4166,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'positiveparenting': {
    term_id: 4567,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'posttermpregnancy': {
    term_id: 4426,
    subtab_name: 'Mylo Baby',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'posteriorplacenta': {
    term_id: 4421,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'pottytraining': {
    term_id: 4282,
    subtab_name: 'Mylo Baby',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'preeclampsia': {
    term_id: 420,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'pregnancyat30': {
    term_id: 4524,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'pregnancyat40': {
    term_id: 4525,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'pregnancybestfoods': {
    term_id: 6676,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  "pregnancydos&don'ts": {
    term_id: 6675,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'pregnancyprecautions': {
    term_id: 6662,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'pregnancybrain': {
    term_id: 4294,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'pregnancybump': {
    term_id: 4275,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'pregnancydietchart': {
    term_id: 4637,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'pregnancymusic': {
    term_id: 4331,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'pregnancytests': {
    term_id: 4274,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'prematurebabies': {
    term_id: 4258,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'prematuredelivery': {
    term_id: 4257,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'prenataltests': {
    term_id: 6664,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'prenatalyoga': {
    term_id: 6679,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'prenatalvisits': {
    term_id: 4248,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'preparingfordelivery': {
    term_id: 164,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'preparingforschool': {
    term_id: 4522,
    subtab_name: 'Mylo Baby',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'preschool': {
    term_id: 4518,
    subtab_name: 'Mylo Baby',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'preschoolers': {
    term_id: 1927,
    subtab_name: 'Mylo Baby',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'pretermlabour': {
    term_id: 4321,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'problemsinconceiving': {
    term_id: 4541,
    subtab_name: 'Mylo Care',
    l1_category: 'Fertility',
    l2_category: 'NA',
  },
  'products&services': {
    term_id: 4415,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'psychologicaldevelopment': {
    term_id: 4557,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'undefined',
  },
  'pumping': {
    term_id: 4208,
    subtab_name: 'Mylo Baby',
    l1_category: 'Feeding & Lactation',
    l2_category: 'NA',
  },
  'rajasthanibhojan': {
    term_id: 4871,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'rashes': {
    term_id: 4452,
    subtab_name: 'Mylo Baby',
    l1_category: 'Baby Wellness',
    l2_category: 'NA',
  },
  'reading': {
    term_id: 4582,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'recipes': {
    term_id: 4216,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'reflexology': {
    term_id: 4506,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'regularhealthcheckup': {
    term_id: 6630,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'relationships': {
    term_id: 6634,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'rhymes': {
    term_id: 4590,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'rituals&customs': {
    term_id: 4472,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'roleofafather': {
    term_id: 4565,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'roleofapartner': {
    term_id: 4474,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'roundligamentpain': {
    term_id: 4433,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'safeexerciseinpregnancy': {
    term_id: 6678,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'scans&tests': {
    term_id: 4247,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'screentime': {
    term_id: 4585,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'secondchild': {
    term_id: 4480,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'secondaryfertility': {
    term_id: 4540,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'secondtrimester': {
    term_id: 4272,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'sensorydevelopment': {
    term_id: 4564,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'separationanxiety': {
    term_id: 4496,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'sexduringpregnancy': {
    term_id: 6671,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'sexlife': {
    term_id: 4269,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'siblingrivalry': {
    term_id: 4478,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'siblings': {
    term_id: 576,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'sids': {
    term_id: 4552,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'singleparent': {
    term_id: 4566,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'sitting': {
    term_id: 4562,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'skin&hair': {
    term_id: 4487,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'skinproblems': {
    term_id: 4449,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'skinchanges': {
    term_id: 506,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'sleepdeprivation': {
    term_id: 4511,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'sleeptimeessentials': {
    term_id: 4715,
    subtab_name: 'Mylo Baby',
    l1_category: 'Baby Gear',
    l2_category: 'NA',
  },
  'sleepingontheback': {
    term_id: 4507,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'sleepingproblems': {
    term_id: 4509,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'sleepingpositions': {
    term_id: 4273,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'smiling': {
    term_id: 4563,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'snoring': {
    term_id: 538,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'socialdevelopment': {
    term_id: 4236,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'soothers': {
    term_id: 4207,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'sorebreasts': {
    term_id: 4577,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'southindianfood': {
    term_id: 4865,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'spermandeggdonation': {
    term_id: 4544,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'spiderveins/redveins': {
    term_id: 4434,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'spirituality': {
    term_id: 6656,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'startingsolids': {
    term_id: 4223,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'stayathomeparent': {
    term_id: 4320,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'stemcellbanking': {
    term_id: 4330,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'stories': {
    term_id: 4584,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'strangersanxiety': {
    term_id: 4495,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'streetfood': {
    term_id: 4861,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'stress': {
    term_id: 4172,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'stretchmarks': {
    term_id: 4362,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'stroller/pram': {
    term_id: 4460,
    subtab_name: 'Mylo Baby',
    l1_category: 'Baby Gear',
    l2_category: 'NA',
  },
  'stuffynose': {
    term_id: 4428,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'stylingtips': {
    term_id: 6654,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'surrogacy': {
    term_id: 4543,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'swaddling': {
    term_id: 4180,
    subtab_name: 'Mylo Baby',
    l1_category: 'Baby Clothing',
    l2_category: 'NA',
  },
  'sweettreats': {
    term_id: 4867,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'swollenlegs': {
    term_id: 4293,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'symptoms&illnesses': {
    term_id: 6674,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'technology&gadgets': {
    term_id: 4438,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'teethgrinding': {
    term_id: 4313,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'teethblisters': {
    term_id: 4315,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'teethers': {
    term_id: 4314,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'therapies': {
    term_id: 4498,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'thirdtrimester': {
    term_id: 4271,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'tiredness&fatigue': {
    term_id: 4292,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'toothdecay': {
    term_id: 4580,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'tootheruption': {
    term_id: 4581,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'toys&gifts': {
    term_id: 4164,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'travel&holidays': {
    term_id: 4265,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'tv&ott': {
    term_id: 6659,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'twins&triplets': {
    term_id: 4332,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'typesofparenting': {
    term_id: 4568,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'umbilicalcord': {
    term_id: 4550,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'umbilicalcordcomplications': {
    term_id: 6669,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'umbilicalhernia': {
    term_id: 4422,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'upholstery&furnishing': {
    term_id: 6655,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'uti': {
    term_id: 4456,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'vaccinations': {
    term_id: 4246,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'vaginalbleeding': {
    term_id: 4533,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'vaginaldischarge': {
    term_id: 4531,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'varicoseveins': {
    term_id: 4291,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'vertigo': {
    term_id: 4290,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'vitamins&supplements': {
    term_id: 4245,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'vividdreams': {
    term_id: 4429,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'walking': {
    term_id: 4561,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'waterbirth': {
    term_id: 4323,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'waterbreak': {
    term_id: 4322,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'weaning': {
    term_id: 4222,
    subtab_name: 'Mylo Baby',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'weightloss': {
    term_id: 4218,
    subtab_name: 'Mylo Care',
    l1_category: 'Weight',
    l2_category: 'NA',
  },
  'weightrelatedproblems': {
    term_id: 6628,
    subtab_name: 'Mylo Care',
    l1_category: 'Weight',
    l2_category: 'NA',
  },
  'weightgain': {
    term_id: 4219,
    subtab_name: 'Mylo Care',
    l1_category: 'Weight',
    l2_category: 'NA',
  },
  'whitedischarge': {
    term_id: 4532,
    subtab_name: 'Mylo Care',
    l1_category: 'Hygiene',
    l2_category: 'NA',
  },
  'wintercare': {
    term_id: 4485,
    subtab_name: 'Mylo Care',
    l1_category: 'Baby Care',
    l2_category: 'NA',
  },
  'winterstore': {
    term_id: 4995,
    subtab_name: 'Mylo Baby',
    l1_category: 'Baby Clothing',
    l2_category: 'NA',
  },
  'womenspecificissues': {
    term_id: 6627,
    subtab_name: 'Mylo Care',
    l1_category: 'Daily Wellness',
    l2_category: 'NA',
  },
  'workplace': {
    term_id: 4493,
    subtab_name: 'Mylo Care',
    l1_category: 'NA',
    l2_category: 'NA',
  },
  'workingparent': {
    term_id: 4319,
    subtab_name: 'Mylo Care',
    l1_category: 'Pregnancy & New Mom',
    l2_category: 'NA',
  },
  'yoga': {
    term_id: 589,
    subtab_name: ' Mylo Care',
    l1_category: 'Daily Wellness',
    l2_category: 'NA',
  },
};
